/* Keep the product blocks in order; the fitment app owns its own UI. */
(() => {
  if (window.rivalProductOrderReady) return;
  window.rivalProductOrderReady = true;
  const order = () => {
    document.querySelectorAll('.rival-product-page [data-rival-product-compatibility]').forEach(card => {
      const block = card.closest('.product__block');
      const info = card.closest('[id^="ProductInfo-"]');
      if (!block || !info) return;
      const title = info.querySelector('.product__block--title');
      const meta = info.querySelector('.product__block--meta');
      if (title && meta && title.nextElementSibling !== meta) title.after(meta);
      if (card.dataset.noticeDesign === 'listed-blue') {
        const price = info.querySelector('.product__block--price');
        if (price && price.parentElement === block.parentElement && price.nextElementSibling !== block) price.after(block);
        return;
      }
      const stock = info.querySelector('rival-stock-label')?.closest('.product__block');
      if (stock && stock.nextElementSibling !== block) stock.after(block);
      if (card.dataset.state === 'CONFIRMED_FIT' && card.dataset.vehicleLabel) {
        const message = card.querySelector('[data-rival-compatibility-message]');
        const copy = `Compatible with your ${card.dataset.vehicleLabel}`;
        if (message && message.textContent !== copy) message.textContent = copy;
      }
    });
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; order(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-state', 'data-vehicle-label'] });
  order();
})();

/* Mirror the stock app's current, validated display; it remains the sole stock source. */
if (!customElements.get('rival-product-delivery')) {
  customElements.define('rival-product-delivery', class extends HTMLElement {
    connectedCallback() {
      this.label = this.querySelector('[data-delivery-label]');
      this.lead = this.querySelector('[data-delivery-lead]');
      this.context = this.querySelector('[data-delivery-context]');
      this.enquiry = this.querySelector('[data-delivery-enquiry]');
      this.contact = this.querySelector('[data-delivery-contact]');
      this.openEnquiry = () => {
        const button = this.source?.querySelector('[data-stock-enquiry]');
        if (button && !button.hidden && !this.source.hidden) button.click();
      };
      this.enquiry.addEventListener('click', this.openEnquiry);
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.target.closest?.('rival-stock-label') ||
          [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 &&
            (node.matches('rival-stock-label') || node.querySelector('rival-stock-label'))))) this.sync();
      });
      this.observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'data-stock-state', 'class'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.enquiry?.removeEventListener('click', this.openEnquiry);
    }
    sync() {
      this.source = [...document.querySelectorAll('.rival-product-page rival-stock-label')]
        .find(source => source.dataset.productId === this.dataset.productId);
      const sourceLabel = this.source?.querySelector('[data-stock-label]');
      const sourceLead = this.source?.querySelector('[data-stock-lead]');
      const visible = this.source && !this.source.hidden && sourceLabel && !sourceLabel.hidden;
      this.label.textContent = visible ? sourceLabel.textContent : 'Check availability with our team';
      this.lead.textContent = visible && sourceLead && !sourceLead.hidden ? sourceLead.textContent : '';
      this.lead.hidden = !this.lead.textContent;
      const state = visible ? sourceLabel.dataset.stockState : '';
      const descriptions = {
        rival: 'Held at Rival. Availability is for your selected option and quantity.',
        supplier: 'Held by a supplier. Supplier availability and delivery timing can change.',
        made_to_order: 'Made after ordering. Check the production or dispatch estimate shown.',
        supplier_order: 'Ordered from the supplier. Check the estimate shown before planning fitting.'
      };
      this.context.textContent = descriptions[state] || 'Ask us to confirm availability and timing before ordering.';
      const sourceEnquiry = this.source?.querySelector('[data-stock-enquiry]');
      const canEnquire = visible && sourceEnquiry && !sourceEnquiry.hidden;
      this.enquiry.hidden = !canEnquire;
      this.contact.hidden = !!canEnquire;
    }
  });
}
